module.exports = __webpack_public_path__ + "img/platform-swiggy.56ea1d42.svg";